import { render, staticRenderFns } from "./ContratacaoDetalhesCardMensagens.vue?vue&type=template&id=18eb5c31&"
import script from "./ContratacaoDetalhesCardMensagens.vue?vue&type=script&lang=js&"
export * from "./ContratacaoDetalhesCardMensagens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports